import { FrameContexts } from '@microsoft/teams-js';
import { IDialogService } from '../../public/interfaces/IDialogService';
import { HandlerType, HostMessageType, IMessageHandler } from './interfaces/IMessageHandler';

export const callServiceAndFormulateAppMessageResult = async <TResult>(
  serviceCall: (...params: unknown[]) => Promise<TResult>,
  ...params: unknown[]
): Promise<void> => {
  await serviceCall(...params);
  return Promise.resolve();
};

type ErrorCallbackType = (error: any, scenario?: any) => Promise<void>;
type MessageHandlerRegistration = {
  callback: HandlerType;
  errorCallback?: ErrorCallbackType;
};

/**
 * Base Message handler which checks for SDK initialization before executing message requests.
 */
export class DialogsMessageHandler implements IMessageHandler {
  protected handlers: {
    [func: string]: MessageHandlerRegistration;
  } = {};

  constructor(protected dialogService?: IDialogService) {}

  public registerHandler(
    message: string,
    callback: HandlerType,
    options?: {
      errorCallback?: ErrorCallbackType;
      isPrivate?: boolean;
    }
  ): void {
    this.handlers[message] = {
      callback,
      errorCallback: options?.errorCallback,
    };
  }

  public deleteMessageHandling(message: string): void {
    delete this.handlers[message];
  }

  public canHandleMessage(__message: string): boolean {
    // TODO
    return true;
  }

  public async handleMessage(message: string, args: any, __clientTimestamp?: number): Promise<void> {
    const handler = this.handlers[message];

    try {
      this.validateDependencies();
      await handler.callback(args);
    } catch (error) {
      if (handler.errorCallback) {
        handler.errorCallback(error);
      } else {
        Promise.reject(error);
      }
    }
  }

  public initHandlers(): void {
    let frameContext = window.parent != window.self ? FrameContexts.task : FrameContexts.content;
    if (frameContext === FrameContexts.task) {
      if (!this.dialogService) {
        throw new Error('DialogService needs to be provided for FrameContexts.task');
      }
    }

    this.registerHandler(HostMessageType.DialogSubmit, async (result?: string | Object) =>
      callServiceAndFormulateAppMessageResult(this.dialogService!.submit, result)
    );
  }

  protected validateDependencies() {
    if (!this.dialogService) {
      throw 'No dialogService provided';
    }
  }

  public cleanup(): void {}
}
